module.exports = __webpack_public_path__ + "static/media/noxx-band.57b6cab1.pdf";